import { useEffect, useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/Card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { format } from "date-fns";
import { ReminderDTO, ReminderApi } from "./ReminderApi";
import { debounce } from "lodash";
import { ReloadIcon } from "@radix-ui/react-icons";

export default function ReminderList() {
  const [reminders, setReminders] = useState<ReminderDTO[]>([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    frequency: "",
    active: "",
  });

  const fetchReminders = async () => {
    setLoading(true);
    try {
      const params = {
        name: filters.name,
        frequency: filters.frequency,
        active: filters.active,
      };
     //const response = await axios.get("/api/reminders", { params });
     const response = await ReminderApi.filter({});
      setReminders(response.data.content || []);
    } catch (error) {
      console.error("Error fetching reminders", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchReminders = debounce(fetchReminders, 300);

  useEffect(() => {
    debouncedFetchReminders();
    return () => debouncedFetchReminders.cancel();
  }, [filters]);

  return (
    <Card className="p-4">
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Input
            placeholder="Search by name"
            value={filters.name}
            onChange={(e) => setFilters({ ...filters, name: e.target.value })}
          />
          <Input
            placeholder="Search by frequency (DAILY, WEEKLY...)"
            value={filters.frequency}
            onChange={(e) => setFilters({ ...filters, frequency: e.target.value })}
          />
          <Input
            placeholder="Active (true / false)"
            value={filters.active}
            onChange={(e) => setFilters({ ...filters, active: e.target.value })}
          />
        </div>

        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Frequency</TableHead>
                <TableHead>Start Time</TableHead>
                <TableHead>Next Reminder</TableHead>
                <TableHead>Active</TableHead>
                <TableHead>Channels</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {reminders.map((reminder) => (
                <TableRow key={reminder.id}>
                  <TableCell>{reminder.name}</TableCell>
                  <TableCell>{reminder.frequency}</TableCell>
                  <TableCell>{format(new Date(reminder.startTime), "yyyy-MM-dd HH:mm")}</TableCell>
                  <TableCell>
                    {reminder.nextReminderTime
                      ? format(new Date(reminder.nextReminderTime), "yyyy-MM-dd HH:mm")
                      : "N/A"}
                  </TableCell>
                  <TableCell>{reminder.active ? "✅" : "❌"}</TableCell>
                  <TableCell>{reminder.channels?.join(", ")}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {loading && (
            <div className="flex justify-center p-4 text-sm text-gray-500">
              <ReloadIcon className="mr-2 animate-spin" />
              Loading...
            </div>
          )}
          {!loading && reminders.length === 0 && (
            <div className="p-4 text-center text-gray-400">No reminders found.</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}